/*
 *  I14V3VREGULI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 16:48:13 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I14V3VREGUL_SECTION_0_TITLE: 'Dimensionnez votre vanne 3 voies en fonction du Kvs et de votre installation',
  I14V3VREGUL_in_kvVanne: 'KVs De la vanne V3V',
  I14V3VREGUL_in_debitCircuit: 'Débit du circuit',
  I14V3VREGUL_I11PERCHARES: 'Calculez la perte de charge ou saississez une valeur manuelle',
  I14V3VREGUL_in_pdcReseau: 'Perte de charge Réseau Qr 100%',
  I14V3VREGUL_SECTION_1_TITLE: '',
  I14V3VREGUL_perteCharg_uuid: 'Unité de calcul de la perte de charge',
  I14V3VREGUL_res_pdcVanne: 'Perte de charge de la vanne',
  I14V3VREGUL_res_autoriteA: 'Autorité de la vanne A',
  I14V3VREGUL_res_autoriteA_BASSE: 'Trop basse',
  I14V3VREGUL_res_autoriteA_HAUTE: 'Trop haute'
}
